import { GiftOutlined } from '@ant-design/icons-vue';
import PointsList from '@/views/points/PointsList.vue';
import PointsRecord from '@/views/points/PointsRecord.vue';

export const pointsFolderRoute = {
    path: 'points',
    name: 'Points',
    redirect: '/points/points-list',
    meta: {
        title: '積分管理',
        icon: GiftOutlined
    },
    children: []
};

export const pointsChildrenRoutes = [
    {
        path: 'points-list',
        component: PointsList,
        name: 'PointsList',
        meta: {
            title: '會員積分'
        }
    },
    {
        path: 'points-record',
        component: PointsRecord,
        name: 'PointHistory',
        meta: {
            title: '積分紀錄'
        }
    }
];
